import { DeviceInfo } from 'qunar-react-native';
import UiState from './uiState';
import OrderList from '../../Views/OrderList/store';
import HasShare from './hasShare';
import URLS from '../../Constant/urls';
import { getInfoById } from '../../Constant/filterBarData';
import invalidLoginCodeMap from '../../Constant/invalidLoginCodeMap';
import * as loginUtil from '../../Utils/loginUtil';
import { qav } from '../../Utils/qav';
// import { LoginManager } from '../../Utils/LoginManager';
import LoginManager  from '../../Utils/LoginManager';
import GuideWeChat, { GuideWeChatStoreInterface } from '../guideWeChat';
import Size from '../size';
import getQueryParam from '../../Utils/getQueryParam';

const { isWeb } = DeviceInfo;
export interface SearchResultStoreModel {
    pageName: string;
    uiState: UiState;
    hasShare: HasShare;
    orderlist: OrderList;
    ordertoken: any;
    loginManager: LoginManager;
    hyId: string;
    guideWeChat: GuideWeChatStoreInterface;
    size: Size;

    setOrdertoken(token: string): void;
    setQueryYear(queryYear: number): void;
    onDataLoaded(loadType: string, data: { orderList: any[]; serverStatus: string }): void;
    onNetworkError(): void;
    initCallbackCreator(isCold?: boolean): void;
    resetPage(businessId?: string, isCold?: boolean): void;
}

class RootStore implements SearchResultStoreModel {
    public pageName = 'order_rn_main';
    public uiState: UiState;
    public hasShare: HasShare;
    public orderlist: OrderList;
    public ordertoken: any;
    public queryYear: number;
    public loginManager: LoginManager;
    public hyId: string;
    public guideWeChat: GuideWeChatStoreInterface;
    public size: Size;

    public constructor() {
        this.uiState = new UiState(this);
        this.hasShare = new HasShare(this);
        this.guideWeChat = new GuideWeChat(this);
        this.size = new Size(this);
        this.orderlist = new OrderList(
            {
                pageName: this.pageName,
                pageSize: 10,
                url: URLS.orderlist,
                method: 'POST',
                ordertoken: this.ordertoken,
                useCache: true,
                onNetworkError: this.onNetworkError,
                onDataLoaded: this.onDataLoaded,
                initCallbackCreator: this.initCallbackCreator
            },
            this
        );
        this.loginManager = new LoginManager()
        this.hyId = 'cmn_order_rn'
    }

    public setOrdertoken(ordertoken: string) {
        this.ordertoken = ordertoken;
    }

    public setQueryYear(queryYear: number) {
        this.queryYear = queryYear;
    }

    public onDataLoaded = async (
        loadType: string,
        data: { orderList: any[]; serverStatus: string }
    ) => {
        const { orderList = [], serverStatus } = data;

        // 关闭删除功能
        this.orderlist.toggleDeleteable(false);

        if (invalidLoginCodeMap[serverStatus]) {
            // global.$loginSucCb = () => {
            //     this.resetPage(this.uiState.businessId);
            // };
            this.loginManager.loginSucCb = () => {
                this.resetPage(this.uiState.businessId);
            };
        }

        if (loadType !== 'loadMore' && !Boolean(isWeb && getQueryParam('fromChannel'))) {
            this.hasShare.checkHasShare();
        }

        if (orderList.length > 0) {
            // 未登录，有本地订单，展示登录
            this.uiState.toggleShowLoginBar(!(await loginUtil.isLogin()));
        } else {
            this.uiState.toggleShowLoginBar(false);
        }
    };

    public onNetworkError = () => {
        this.uiState.toggleShowLoginBar(false);
    };

    public initCallbackCreator = (isCold = true) => {
        const { statusFilter, sourceFrom, businessId } = this.uiState;
        return (params: { showSuc: any; failReason: string }) => {
            const { showSuc, failReason } = params;
            qav({
                page: this.pageName,
                source: sourceFrom,
                operType: 'enter',
                ext: {
                    isCold,
                    filter: businessId,
                    status: statusFilter,
                    showSuc,
                    failReason
                }
            });
        };
    };

    // 重置页面，只在初始化页面和切换筛选栏时会调用次函数
    public resetPage = async (businessId = this.uiState.businessId, isCold = true) => {
        const businessInfo = getInfoById(businessId);

        if (!businessInfo) {
            console.warn('传入的businessType有误，必须是以下值之一');
            return
        }
        const isLogin = Boolean(await loginUtil.isLogin());
        this.uiState.setBusinessId(businessId);
        this.uiState.setIsLogin(isLogin);
        // 每次切换，必然要重新设置请求参数
        // 处理指定年份
        let startDate, endDate;
        if (this.queryYear > 0) {
            startDate = `${this.queryYear}-01-01`;
            endDate = `${this.queryYear}-12-31`;
        }
        this.orderlist.setRequestParams({
            businessTypes: this.uiState.businessValue,
            orderToken: this.ordertoken,
            startDate,
            endDate,
            userNameQuery: false,
            source: this.uiState.sourceFrom,
            // 三端统一接口新加参数
            userPhoneQuery:true,
            tokenQuery:!!this.ordertoken
        });
        // 关闭删除功能
        this.orderlist.toggleDeleteable(false);
        // 调用init方法，获取数据
        this.orderlist.scrollTopAndInit(isCold);
    };
}

// export default new RootStore();
export default RootStore;
